// extracted by mini-css-extract-plugin
export default {"Title":"Clients_Title__7vp-9","Pagination":"Clients_Pagination__dv9rB"};